/**
 * Sprint 44 · Body-Scroll-Lock-Hook für Modals.
 *
 * Verhindert dass das hinter dem Modal liegende Fenster mitscrollt wenn
 * der User im Modal-Content scrollt. Auf iPhone besonders nervig weil
 * Touch-scroll auf overlay den ganzen Body bewegt.
 *
 * Verwendung:
 *   useModalScrollLock(open);
 *
 * Setzt auf <body> die Klasse 'body--modal-open' während open=true.
 * Mehrere Modals stacken sich (counter-based) — wenn 2 Modals offen sind,
 * bleibt der Lock aktiv bis beide zu sind.
 */
import { useEffect } from 'react';

let lockCount = 0;
let savedScrollY = 0;

function applyLock(): void {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    document.body.style.top = `-${savedScrollY}px`;
    document.body.classList.add('body--modal-open');
  }
  lockCount += 1;
}

function releaseLock(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.classList.remove('body--modal-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }
}

export function useModalScrollLock(open: boolean): void {
  useEffect(() => {
    if (!open) return;
    applyLock();
    return () => {
      releaseLock();
    };
  }, [open]);
}
